require('./amazonGiftCardDetails.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { formatText } = require('core/i18n').i18n;
//@ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const currencyHelper = require('utilities/currencyHelper');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
//@constants
const { EURO_TEXT } = require('constants/index');
//utlities
const { toCamelCase } = require('utilities/stringHelper');

class AmazonGiftCardDetails extends React.Component {

    render(){
        let accountSelected;
        let amount;
        let emailLabel;
        let giftVoucherAmount;
        let immOriginAccount;
        let originAccountText = formatText('buyAmazonGiftCard-toBeDefined');
        const currency = currencyHelper.formatCurrency(EURO_TEXT);
        const {
            columnCount,
            email,
            immAccounts,
            giftVoucherAmountKey,
            immSteps,
            showEmailLabel,
        } = this.props;

        if (!!immSteps) {
            accountSelected = immSteps.getIn(['0','accountSelected']);
            amount = immSteps.getIn(['0','amount']);
            giftVoucherAmount = immSteps.getIn(['0','giftVoucherAmount']);
        }

        if (!!accountSelected) {
            immOriginAccount = immAccounts.getIn(['byId', accountSelected]);
        }

        if (!!immOriginAccount) {
            originAccountText = immOriginAccount.get('alias') || toCamelCase(immOriginAccount.get('accountType'));
            if (__CONTACT_CENTER__) {
                originAccountText = `${originAccountText} ${immOriginAccount.get('iban')}`;
            } else {
                originAccountText = `${originAccountText} ...${immOriginAccount.get('iban').substr(-4)}`;
            }
        }

        const giftVoucherAmountObject = {
            amount: giftVoucherAmount,
            currency: currency
        };

        const giftVoucherTitle = giftVoucherAmountKey ? formatText(giftVoucherAmountKey) : formatText('buyAmazonGiftCard-giftVoucherAmount');

        if (showEmailLabel && email) {
            emailLabel = (
                <OKInformativeListItem
                    bodyText={email}
                    title={formatText('buyAmazonGiftCard-emailLabel')}
                />
            );
        }

        return(
            <section className="amazon-gift-card-details">
                <OKInformativeList columns={columnCount}>
                    <OKInformativeListItem
                        bodyText={originAccountText}
                        bodyWordBreak={!__CONTACT_CENTER__}
                        title={formatText('buyAmazonGiftCardStep-accountLabel')}
                    >
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        bodyText={currencyHelper.getFormattedString({ amount, currency })}
                        title={giftVoucherTitle}
                    />
                    {emailLabel}
                    <OKInformativeListItem
                        title={formatText('buyAmazonGiftCard-amountLabel')}
                    >
                        <span className="amazon-gift-card-details__gift-voucher-amount">
                            <OneLineSymbolAmount
                                amountObject={giftVoucherAmountObject}
                                amountObjectFormatted={currencyHelper.formatAmountObject(giftVoucherAmountObject, true)}
                            />
                        </span>
                    </OKInformativeListItem>
                </OKInformativeList>
            </section>
        );
    }
}

AmazonGiftCardDetails.propTypes = {
    accountBuyAmazonGiftCard: PropTypes.object,
    columnCount: PropTypes.number,
    email:PropTypes.string,
    giftVoucherAmountKey: PropTypes.string,
    immSteps: PropTypes.object,
    immAccounts: PropTypes.object,
    showEmailLabel: PropTypes.bool
}

AmazonGiftCardDetails.defaultProps = {
    showEmailLabel: false
}

module.exports = AmazonGiftCardDetails;
